import { render, staticRenderFns } from "./EmojiIcon.vue?vue&type=template&id=10a82124&scoped=true"
import script from "./EmojiIcon.vue?vue&type=script&lang=js"
export * from "./EmojiIcon.vue?vue&type=script&lang=js"
import style0 from "./EmojiIcon.vue?vue&type=style&index=0&id=10a82124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a82124",
  null
  
)

export default component.exports